import { Layout } from "../components/shared/Layout"
import React, { useEffect, useState } from "react"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { useTranslation } from "next-i18next"
import { AccountInfo } from "../components/my-account/AccountInfo"
import { EditAccount } from "../components/my-account/EditAccount"
import useGlobalStore from "../hooks/useGlobalStore"
import useSWR from "swr"
import { getProfile } from "../services/account"
import { PencilSvg, Person1Svg } from "../assets/svg"
import { LeftMenu } from "../components/shared/LeftMenu"
import { useRouter } from "next/router"

export async function getServerSideProps({ locale }) {
    return {
        props: {
            ...(await serverSideTranslations(locale, ["common", "my-account"]))
        }
    }
}

function MyAccount() {
    const router = useRouter()
    const { t: tCommon } = useTranslation("common")
    const { t: tMyAccount } = useTranslation("my-account")
    const { isLoggedIn, setIsOpenLoginModal, isValidAccount } = useGlobalStore()

    const [isShowEdit, setIsShowEdit] = useState(false)

    const fetcher = async () => {
        const response = await getProfile()

        return response.data.data
    }

    const { data: profile } = useSWR(isLoggedIn ? `MY_PROFILE_${isLoggedIn}` : null, fetcher)

    let timeout
    useEffect(() => {
        if (!isLoggedIn) {
            timeout = window.setTimeout(() => {
                setIsOpenLoginModal(true)
            }, 2200)
        } else {
            setIsOpenLoginModal(false)

            const highestId = window.setTimeout(() => {
                for (let i = highestId; i >= 0; i--) {
                    window.clearTimeout(i)
                }
            }, 0)
        }
    }, [isLoggedIn])

    return (
        <Layout>
            <div className={"flex"}>
                <div className={"hidden lg:block"}>
                    <LeftMenu router={router} />
                </div>
                <div
                    className={
                        "ml-[18px] mr-[18px] min-h-[40vh] w-full pb-[40px] lg:ml-4 lg:mr-[40px] lg:min-h-[80vh] lg:pb-0"
                    }
                >
                    <div className={"mt-5 ml-2 flex items-center justify-between text-20 font-bold leading-6"}>
                        <div className={"flex items-center"}>
                            <Person1Svg width={17} height={19} className={"mr-[10px] fill-accent-1"} />
                            {tMyAccount("title")}
                        </div>
                        {!isShowEdit && isLoggedIn && (
                            <div className={"b-flex-center lg:hidden"}>
                                <button
                                    onClick={() => setIsShowEdit(true)}
                                    className={
                                        "b-flex-center h-[23px] w-[87px] rounded-[5px] bg-[#D7D7D7] text-14 hover:text-accent-1"
                                    }
                                >
                                    {tCommon("button.modify")}
                                    <PencilSvg width={13} height={13} className={"ml-2"} />
                                </button>
                            </div>
                        )}
                    </div>
                    {isLoggedIn && (
                        <>
                            {!isShowEdit && profile && (
                                <AccountInfo profile={profile} onEdit={() => setIsShowEdit(true)} />
                            )}
                            {isShowEdit && profile && (
                                <EditAccount profile={profile} onCancel={() => setIsShowEdit(false)} />
                            )}
                        </>
                    )}
                </div>
            </div>
        </Layout>
    )
}

export default MyAccount
